module.exports = __webpack_public_path__ + "img/au.54e6d58c.svg";